import styled from 'styled-components/macro';
import { COLORS, CHAT_ROOM_TABS_HEIGHT } from 'styleguide';

const PADDING = '16px';

const TabsWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  height: calc(${CHAT_ROOM_TABS_HEIGHT} - ${PADDING});
  padding-bottom: 5px;
  border-bottom: 1px solid ${COLORS.line};
  background-color: ${COLORS.black};
`;

export default TabsWrapper;
